// extracted by mini-css-extract-plugin
export default {"suspenseContainer":"routes_component_suspenseContainer__DIO5Y"};